/*
 * Copyright 2026 Sony Corporation
 */

import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';

import type { SceneDoc } from '../../scene-doc/schema';

export interface OutlinerProps {
  doc: SceneDoc;
  selection: readonly string[];
  onSelect: (ids: readonly string[]) => void;
}

/** What is in the scene, in the order it was put there. */
export const Outliner = ({ doc, selection, onSelect }: OutlinerProps) => (
  <Box className="flex min-h-0 flex-1 flex-col">
    {doc.nodes.length === 0 ? (
      <Typography variant="body2" color="text.secondary" className="px-4 py-6 text-center">
        Nothing here yet
      </Typography>
    ) : (
      <List dense className="flex-1 overflow-y-auto">
        {doc.nodes.map((node) => (
          <ListItemButton
            key={node.id}
            selected={selection.includes(node.id)}
            onClick={() => onSelect([node.id])}
            className="py-0.5"
          >
            <ListItemIcon className="min-w-8">
              {node.kind === 'light' ? (
                <LightbulbOutlinedIcon fontSize="small" />
              ) : (
                <ViewInArOutlinedIcon fontSize="small" />
              )}
            </ListItemIcon>
            <ListItemText primary={node.name} slotProps={{ primary: { variant: 'body2' } }} />
          </ListItemButton>
        ))}
      </List>
    )}
  </Box>
);
